import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, fetchDataActive, activateData, fetchData1, deleteData2, fetchDatalist } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { IconButton, Modal, Button, TextField, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select';
import {
  Search as SearchIcon,

  Edit as EditIcon,
  Delete as DeleteIcon,
  Category
} from '@mui/icons-material';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import axios from 'axios';
import { Cloudinary } from 'cloudinary-core';
import { v4 as uuidv4 } from 'uuid';
const MemberEdit = () => {
  const { id } = useParams();
  const history = useHistory();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isIdValid, setIsIdValid] = useState(true);
  const { isAuthenticated, branchId, clubId, userId, logout, token } = useAuth();
  const [memberlist, setMemberOptions] = useState([]);
  const [familyModalOpen, setFamilyModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    memberId: '',
    category: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    dateOfJoining: '',
    weddingAnniversary: '',
    originalRotaryDate: '',
    proposedByMemberId: null,
    proposedMemberName: '',
    classification: '',
    firmName: '',
    occupation: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    rotaryRecognition: null,
    onlineAccountwithmyRotary: null,
    email: '',
    phoneNumber: '',
    phoneNumber1: '',
    remark: '',
    gender: '',
    bloodGroupId: '',
    bloodGroupName: '',
    dateofleavingfrom: '',
    dateofleavingTo: '',
    expirydate: '',
    status: '',
    admittedDate: '',

  });

  const [deleteMember, setDeleteMember] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  // const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedgroupchild, setselectedgroupchild] = useState("");
  const [bloodGroupOptions, setBloodGroupOptions] = useState([]);
  const [selectedgroup, setSelectedGroup] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newRecordData, setNewRecordData] = useState({
    name: '',
    dateOfBirth: '',
    bloodGroupId: '',
    relation: '',
    isRotarian: false,

  });

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [MemberFamilyDatas, setMemberFamilyDatas] = useState([]);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [uploadedImageName, setUploadedImageName] = useState('');
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  //fees
  const [feesModalOpen, setFeesModalOpen] = useState(false);
  const [feeslist, setFeesOptions] = useState([]);
  const [feestype, setFeesType] = useState("");
  const [selectedfees, setselectedfees] = useState("");
  const [feesAmount, setFeesAmount] = useState("");
  const [feesDescription, setFeesDescription] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }

    if (id) {
      fetchData('MemberApi', `/GetMemberDetails/${id}`, token)
        .then((response) => {
          if (response.responseCode === '1111') {
            const memberDatas = response.response_data.memberdata;
            const familyDatas = response.response_data.familydata;
            setFormData({
              ...memberDatas,
              UpdatedBy: userId,
            });
            if (Array.isArray(familyDatas)) {
              setMemberFamilyDatas(familyDatas);
            } else {
              console.error('Expected an array for familyDatas but got:', familyDatas);
              setMemberFamilyDatas([]);
            }
            const imageUrl = `https://res.cloudinary.com/dm9pk2viy/image/upload/v1/Rotary/member/${memberDatas.branchId}/${memberDatas.firstName}_${memberDatas.id}_${memberDatas.profileguid}.jpg`;
            setProfilePhoto(imageUrl);
          } else {
            setIsIdValid(false);
            setErrorMessage('Invalid ID. No record found.');
          }
        })
        .catch((error) => {
          console.error('Error fetching Member Details:', error);
          setIsIdValid(false);
          setErrorMessage('Failed to fetch member details.');
        });
    } else {
      setIsIdValid(false);
      setErrorMessage('Invalid ID. Please try again.');
    }
  }, [id, isAuthenticated, token, logout, familyModalOpen]);

  const fetchMember = async () => {
    try {
      const params1 = `/${clubId}`;
      const params2 = `?branchId=${branchId}`;
      // const response = await fetchData1('MemberApi', params1, params2, token);
      const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(member => ({
          value: member.id,
          label: member.firstName,
        }));
        setMemberOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Member:', error);
    }
  };

  useEffect(() => {
    if (selectedfees) {
      let fromDate = new Date();
      let toDate = new Date();

      if (selectedfees.type == 1) {
        // Monthly: First to last day of the current month
        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
        toDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0);
      } else if (selectedfees.type == 2) {
        // Quarterly: First to last day of the current quarter
        const currentMonth = fromDate.getMonth();
        const quarterStartMonth = currentMonth - (currentMonth % 3);
        const quarterEndMonth = quarterStartMonth + 2;

        fromDate = new Date(fromDate.getFullYear(), quarterStartMonth, 1);
        toDate = new Date(fromDate.getFullYear(), quarterEndMonth + 1, 0);
      } else if (selectedfees.type == 3) {
        // Half-Yearly: First to last day of the current half-year
        const currentMonth = fromDate.getMonth();
        const halfYearStartMonth = currentMonth < 6 ? 0 : 6;
        const halfYearEndMonth = halfYearStartMonth + 5;

        fromDate = new Date(fromDate.getFullYear(), halfYearStartMonth, 1);
        toDate = new Date(fromDate.getFullYear(), halfYearEndMonth + 1, 0);
      } else if (selectedfees.type == 4) {
        // Financial Year: July 1 to June 30
        const currentMonth = fromDate.getMonth(); // 0-based (May is 4)
        const currentYear = fromDate.getFullYear();

        if (currentMonth >= 6) {
          // If current month is July (6) or later, start date is July 1 of current year
          fromDate = new Date(currentYear, 6, 1); // July 1
          toDate = new Date(currentYear + 1, 5, 30); // June 30 next year
        } else {
          // If current month is before July, start date is July 1 of previous year
          fromDate = new Date(currentYear - 1, 6, 1); // July 1 last year
          toDate = new Date(currentYear, 5, 30); // June 30 this year
        }
      }

      // Format dates as "DD-MM-YYYY"
      const formatDate = (date) => {
        return date.toLocaleDateString("en-GB").split('/').reverse().join('-');
      };

      setFromDate(formatDate(fromDate));
      setToDate(formatDate(toDate));
    }
  }, [selectedfees]);
  const fetchBloodGroup = async () => {
    try {
      const response = await fetchDataActive('MemberApi', token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map((bgroup) => ({
          value: bgroup.id,
          label: bgroup.group,
        }));
        setBloodGroupOptions(options);  // Set the fetched blood group options
      }
    } catch (error) {
      console.error('Error fetching Blood Group:', error);
    }
  };

  useEffect(() => {
    fetchBloodGroup();
    fetchMember();
    fetchFees();
  }, [token]);

  const fetchFees = async () => {
    try {
      // const response = await fetchData('ClubFeesApi', `/${clubId}`, token)
      const response = await fetchData1('ClubFeesApi', `/c/${clubId}/${branchId}/${1}`, token)
      if (response.responseCode === '1111') {

        const options = response.response_data.map(fees => ({
          value: fees.id,
          label: fees.feesDescription,
          type: fees.feesRecuringType,
          amount: fees.feesAmount,

        }));
        setFeesOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Fees:', error);
    }
  };

  const handleBloodGroupChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      bloodGroupId: selectedOption ? selectedOption.value : null,  // Update formData with selected blood group
      bloodGroupName: selectedOption ? selectedOption.label : '',  // Optionally store the blood group name
    }));
  };

  const handleMemberChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      proposedByMemberId: selectedOption ? selectedOption.value : null,  // Update formData with selected blood group
      memberName: selectedOption ? selectedOption.label : '',  // Optionally store the blood group name
    }));
  };

  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? !prevData[name] : value,
    }));
  };

  const handleOnlineChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update gender based on the selected value
    }));
  };

  const handleGenderChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update gender based on the selected value
    }));
  };

  const handleCategoryChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update gender based on the selected value
    }));
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return ''; // Handle cases where dateString is undefined or null
    const currentDate = new Date(dateString);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSubmit
    = async (e) => {
      // e.preventDefault();
      if (!formData.firstName || !formData.lastName)// || !formData.dateOfJoining||!formData.memberId 
      //  ||!formData.admittedDate) //) 
      {
        setErrorMessage("All fields are required!");
        return;
      }
      const guidnew = uuidv4();
      const publicId = `${formData.firstName}_${formData.id}_${guidnew}`;
      const CreateData = {
        Id: formData.id,
        FirstName: formData.firstName || null,  // Pass null if lastname is falsy
        LastName: formData.lastName || null,  // Pass null if firstname is falsy
        WeddingAnniversary: formData.weddingAnniversary || null,  // Null if weddinganniversary is falsy
        DateOfJoining: formData.dateOfJoining || null,  // Null if dateofjoining is falsy
        DateOfBirth: formData.dateOfBirth || null,  // Null if dateofbirth is falsy
        PhoneNumber: formData.phoneNumber || null,  // Null if phonenumber is falsy
        Email: formData.email || null,  // Null if email is falsy
        Remark: formData.remark || null,  // Null if remark is falsy
        CreatedBy: formData.createdBy, // Null if userId is falsy (unlikely for userId)
        CreatedDate: formData.createdDate,  // Always generate the current date
        ModifiedBy: userId,
        ModifiedDate: new Date(),
        BloodGroupId: formData.bloodGroupId,
        Gender: formData.gender || null,  // Null if gender is falsy
        ClubId: clubId, // Null if clubId is falsy
        UserTypeId: 4, // Default to 4 (doesn't need a null check)
        Expirydate: formData.expirydate,
        DateOfLeavingFrom: formData.dateOfLeavingFrom,
        DateOfLeavingTo: formData.dateOfLeavingTo,
        IsLoginNeeded: true,
        Status: formData.status,
        profileguid: guidnew,
        OriginalRotaryDate: formData.originalRotaryDate,
        ProposedByMemberId: formData.proposedByMemberId,
        Classification: formData.classification,
        FirmName: formData.firmName,
        Occupation: formData.occupation,
        Address: formData.address,
        City: formData.city,
        State: formData.state,
        PostalCode: formData.postalCode,
        Country: formData.country,
        PhoneNumber1: formData.phoneNumber1,
        RotaryRecognitions: null,
        RotaryRecognition: formData.rotaryRecognition,
        OnlineAccountwithmyRotary: formData.onlineAccountwithmyRotary,
        DateOfJoining: formData.admittedDate || null,
        AdmittedDate: formData.admittedDate || null,
        MemberId: formData.memberId || null,
        CategoryId: formData.category || null,

      };

      const familyMembers = MemberFamilyDatas.map(member => ({
        Name: member.name || null,
        Id: member.id,
        ClubId: clubId,
        DateOfBirth: member.dateOfBirth || null,
        BloodGroupId: member.bloodGroupId || null,
        Relation: member.relation || null,
        CreatedBy: member.id === 0 ? userId : member.createdBy,
        CreatedDate: member.id === 0 ? new Date() : member.createdDate,
        ModifiedBy: member.id === 0 ? userId : member.ModifiedBy,
        ModifiedDate: member.id === 0 ? new Date() : member.ModifiedDate,
        isRotarian: member.isRotarian,

      }));

      const MemberAndFamilyView = {
        memberdata: CreateData,
        familydata: familyMembers, // Include child data as 'FamilyMembers'
      };

      try {
        const response = await updateData('MemberApi', id, MemberAndFamilyView, token);
        console.log('Record updated successfully:', response);
        if (selectedFile) {
          try {
            // Upload the new image, which will overwrite the existing image
            const formData1 = new FormData();
            formData1.append('file', selectedFile);
            formData1.append('upload_preset', 'testupload'); // Replace with your upload preset
            formData1.append('folder', `Rotary/member/${branchId}`);  // Specify the folder structure
            formData1.append('public_id', publicId); // Specify the public ID (file name without extension)

            const uploadResponse = await axios.post(`https://api.cloudinary.com/v1_1/dm9pk2viy/image/upload`, formData1);
            const imageUrl = uploadResponse.data.secure_url; // URL of the uploaded image
            setUploadedImageName(selectedFile.name);
            setUploadedImageUrl(imageUrl);
            setProfilePhoto(imageUrl); // Update the profile photo state with the new image URL
          } catch (error) {
            console.error('Error uploading image to Cloudinary:', error);
          }
        }
        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);

        history.push('/MemberIndex');

      } catch (error) {
        console.error('Error updating record:', error);
      }
    };
  const handleActivate = (memberId) => {
    activateData('MemberApi', `${memberId}`)
      .then(() => {
        fetchData();
      })
      .catch((error) => {
        console.error('Error activating record:', error);
      });
  };

  //-------------------------------------------------------------------------------

  const [familyData, setFamilyData] = useState([]);

  // Function to toggle modal for both adding and editing
  // const toggleModal = (record = null) => {
  //   setSelectedRecord(record);
  //   if (record) {
  //     setNewRecordData(record); // Prefill with existing data for edit
  //   } else {
  //     setNewRecordData({ Name: '', DateOfBirthChild: '', BloodGroupId: '', Relation: '' }); // Clear form for new record
  //   }
  //   setIsModalOpen(!isModalOpen);
  // };

  const toggleModal = (record = null, index = null) => {
    if (record) {
      // Editing mode
      setSelectedRecord({ ...record, index });
      setNewRecordData({ ...record });
    } else {
      // Adding mode (reset form)
      setSelectedRecord(null);
      setNewRecordData({ name: '', dateOfBirth: '', bloodGroupId: '', relation: '', isRotarian: false });
    }
    setIsModalOpen(true);
  };


  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    setNewRecordData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };


  // const addOrEditRecord = () => {
  //   if (selectedRecord !== null) {
  //       // Ensure `newRecordData` is replacing only the necessary fields
  //       setMemberFamilyDatas((prevData) =>
  //           prevData.map((data, index) =>
  //               index === selectedRecord.index
  //                   ? { ...data, ...newRecordData } 
  //                   : data
  //           )
  //       );
  //   } else {
  //       // Adding new record
  //       setMemberFamilyDatas((prevData) => [...prevData, newRecordData]);
  //   }

  //   // Close modal & reset state
  //   setIsModalOpen(false);
  //   setSelectedRecord(null);
  //   setNewRecordData((prevData) => ({
  //       name: '',
  //       dateOfBirth: '',
  //       bloodGroupId: '',
  //       relation: '',
  //       isRotarian: prevData.isRotarian, 
  //   }));
  //   handleSubmit();
  // };



  const addOrEditRecord = () => {
    if (!formData.firstName || !formData.lastName)// || !formData.dateOfJoining||!formData.memberId 
    //  ||!formData.admittedDate) //) 
    {
      setErrorMessage("All fields are required!");
      return;
    }
    const guidnew = uuidv4();
    const publicId = `${formData.firstName}_${formData.id}_${guidnew}`;
    const CreateData = {
      Id: formData.id,
      FirstName: formData.firstName || null,  // Pass null if lastname is falsy
      LastName: formData.lastName || null,  // Pass null if firstname is falsy
      WeddingAnniversary: formData.weddingAnniversary || null,  // Null if weddinganniversary is falsy
      DateOfJoining: formData.dateOfJoining || null,  // Null if dateofjoining is falsy
      DateOfBirth: formData.dateOfBirth || null,  // Null if dateofbirth is falsy
      PhoneNumber: formData.phoneNumber || null,  // Null if phonenumber is falsy
      Email: formData.email || null,  // Null if email is falsy
      Remark: formData.remark || null,  // Null if remark is falsy
      CreatedBy: formData.createdBy, // Null if userId is falsy (unlikely for userId)
      CreatedDate: formData.createdDate,  // Always generate the current date
      ModifiedBy: userId,
      ModifiedDate: new Date(),
      BloodGroupId: formData.bloodGroupId,
      Gender: formData.gender || null,  // Null if gender is falsy
      ClubId: clubId, // Null if clubId is falsy
      UserTypeId: 4, // Default to 4 (doesn't need a null check)
      Expirydate: formData.expirydate,
      DateOfLeavingFrom: formData.dateOfLeavingFrom,
      DateOfLeavingTo: formData.dateOfLeavingTo,
      IsLoginNeeded: true,
      Status: formData.status,
      profileguid: guidnew,
      OriginalRotaryDate: formData.originalRotaryDate,
      ProposedByMemberId: formData.proposedByMemberId,
      Classification: formData.classification,
      FirmName: formData.firmName,
      Occupation: formData.occupation,
      Address: formData.address,
      City: formData.city,
      State: formData.state,
      PostalCode: formData.postalCode,
      Country: formData.country,
      PhoneNumber1: formData.phoneNumber1,
      RotaryRecognitions: null,
      RotaryRecognition: formData.rotaryRecognition,
      OnlineAccountwithmyRotary: formData.onlineAccountwithmyRotary,
      DateOfJoining: formData.admittedDate || null,
      AdmittedDate: formData.admittedDate || null,
      MemberId: formData.memberId || null,
      CategoryId: formData.category || null,

    };

    const familyMembers = [{
      Name: newRecordData.name || null,
      Id: newRecordData.id || 0,
      ClubId: clubId,
      DateOfBirth: newRecordData.dateOfBirth || null,
      BloodGroupId: newRecordData.bloodGroupId || null,
      Relation: newRecordData.relation || null,
      CreatedBy: newRecordData.id === 0 ? userId : newRecordData.createdBy,
      CreatedDate: newRecordData.id === 0 ? new Date() : newRecordData.createdDate,
      ModifiedBy: newRecordData.id === 0 ? userId : newRecordData.ModifiedBy,
      ModifiedDate: newRecordData.id === 0 ? new Date() : newRecordData.ModifiedDate,
      isRotarian: newRecordData.isRotarian,

    }];

    const MemberAndFamilyView = {
      memberdata: CreateData,
      familydata: familyMembers, // Include child data as 'FamilyMembers'
    };

    try {
      const response = updateData('MemberApi', id, MemberAndFamilyView, token);
      console.log('Record updated successfully:', response);
      if (selectedFile) {
        try {
          // Upload the new image, which will overwrite the existing image
          const formData1 = new FormData();
          formData1.append('file', selectedFile);
          formData1.append('upload_preset', 'testupload'); // Replace with your upload preset
          formData1.append('folder', `Rotary/member/${branchId}`);  // Specify the folder structure
          formData1.append('public_id', publicId); // Specify the public ID (file name without extension)

          const uploadResponse = axios.post(`https://api.cloudinary.com/v1_1/dm9pk2viy/image/upload`, formData1);
          const imageUrl = uploadResponse.data.secure_url; // URL of the uploaded image
          setUploadedImageName(selectedFile.name);
          setUploadedImageUrl(imageUrl);
          setProfilePhoto(imageUrl); // Update the profile photo state with the new image URL
        } catch (error) {
          console.error('Error uploading image to Cloudinary:', error);
        }
      }
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);

      // Close modal & reset state
      setIsModalOpen(false);
      setSelectedRecord(null);
      setNewRecordData((prevData) => ({
        name: '',
        dateOfBirth: '',
        bloodGroupId: '',
        relation: '',
        isRotarian: false,
      }));
      setFamilyModalOpen(false); // Close the family modal after adding/editing
      //history.push('/MemberIndex');
      // window.location.reload();
      //setFamilyModalOpen(true); 

    } catch (error) {
      console.error('Error updating record:', error);
    }
  };





  const handleDateOfBirthChange = (event) => {
    setNewRecordData((prevData) => ({
      ...prevData,
      DateOfBirthChild: event.target.value, // Directly update DateOfBirthChild
    }));
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const localUrl = URL.createObjectURL(file);
      setProfilePhoto(localUrl);
      setSelectedFile(file);
    }
  };

  const togglefamilysModal1 = () => {
    setFamilyModalOpen(true);
  };

  const togglefeesModal = () => {
    GenerateData1();
    //setFeesModalOpen(true);
  };
  const togglefeesModalClose = () => {
    setFeesModalOpen(false);
  };

  const togglefamilysModalClose1 = () => {
    setFamilyModalOpen(false);
  };
  const handleDelete = async () => {
    deleteData2('MemberApi', deleteMember, 2, token) // Removed extra `/`
      .then((response) => {

        setDeleteMember(null);
        setConfirmDialogOpen(false);
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });
  };

  const openConfirmDialog = (memberId) => {
    setDeleteMember(memberId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteMember(null);
    setConfirmDialogOpen(false);
  };
  const handleFeesChange = (selectedOption) => {
    setselectedfees(selectedOption);
    setFeesAmount(selectedOption ? selectedOption.amount : ""); // Set amount
    setFeesType(selectedOption ? selectedOption.type : ""); // Set type
  };
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === "fromDate") {
      setFromDate(value);
    } else if (name === "toDate") {
      setToDate(value);
    }
  };

  const GenerateData = async () => {
    if (!selectedfees || !fromDate || !toDate) {
      alert('Please select fee type and date range before generating.');
      return;
    }

    setIsProcessing(true);
    try {
      const response = await fetchData1(
        'ClubFeesApi',
        `/${clubId}/${branchId}/${selectedfees.value}/${formData.id}/${fromDate}/${toDate}`,
        token
      );

      await new Promise(resolve => setTimeout(resolve, 2000)); // optional delay
      alert(response.response);

    } catch (error) {
      if (error.response) {
        console.error('Server Error:', error.response.data);
        alert('Server error. Please try again later.');
      } else if (error.request) {
        console.error('No response received:', error.request);
        alert('No server response. Check your network.');
      } else {
        console.error('Unexpected Error:', error.message);
        alert('Unexpected error occurred.');
      }
    } finally {
      setIsProcessing(false);
    }
  };


  const GenerateData1 = async () => {
    setIsProcessing(true);
    try {
      const response = await fetchData1(
        'ClubFeesApi',
        `/${clubId}/${branchId}/${formData.id}/${0}`,
        token
      );

      await new Promise(resolve => setTimeout(resolve, 2000)); // optional delay
      alert(response.response);

    } catch (error) {
      if (error.response) {
        console.error('Server Error:', error.response.data);
        alert('Server error. Please try again later.');
      } else if (error.request) {
        console.error('No response received:', error.request);
        alert('No server response. Check your network.');
      } else {
        console.error('Unexpected Error:', error.message);
        alert('Unexpected error occurred.');
      }
    } finally {
      setIsProcessing(false);
    }
  };
  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <div className="w-full mb-2 flex">
        <h6 className="productHead flex-grow linkcolor" style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
          MEMBER- EDIT
        </h6>

        <button
          onClick={togglefamilysModal1}
          className="ml-3 text-blue-600 underline cursor-pointer"
          style={{
            background: 'none',
            border: 'none',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginRight: '10px',
          }}
        >
          Family Datas
        </button>
        {/* <button
          onClick={togglefeesModal}
          className="ml-3 text-blue-600 underline cursor-pointer"
          style={{
            background: 'none',
            border: 'none',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginRight: '10px',
          }}
        >
          Generate Fees
        </button> */}


        <button
          onClick={() => {
            const confirmGenerate = window.confirm("Are you sure you want to generate fees?");
            if (confirmGenerate) {
              togglefeesModal(); // Proceed only if user confirms
            }
          }}
          className="ml-3 text-blue-600 underline cursor-pointer"
          style={{
            background: 'none',
            border: 'none',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: 'pointer',
            marginRight: '10px',
          }}
        >
          Generate Fees
        </button>

        <div className="button-container-2" style={{ marginRight: '10px' }}>
          <Button
            onClick={handleSubmit}
            style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px' }}
            disabled={!isIdValid}
          >
            UPDATE
          </Button>
        </div>

        <div className="button-container-3">
          <Button
            type="button"
            onClick={() => history.push('/MemberIndex')}
            className="linkcolor"
            style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#C62300', marginLeft: '5px', height: '25px' }}
          >
            CANCEL
          </Button>
        </div>
      </div>

      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
      {successMessage && <p className="text-green-500">{successMessage}</p>}

      <div className="w-full flex flex-wrap">


        <div className="w-full sm:w-5/5 p-6 bg-white rounded-lg shadow-lg" style={{ width: '100%' }}>
          <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
            <div>
              <label htmlFor="memberId">Member Id
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="memberId"
                value={formData.memberId}
                onChange={handleChange}
                type="text"

              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-medium">Category
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleCategoryChange}
                  className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
                >
                  <option value="1">General</option>
                  <option value="2">Honorary</option>
                  <option value="3">Emeritus</option>
                  <option value="4">Corporate</option>

                </select>
              </label>
            </div>



            <div>
              <label htmlFor="name">First Name
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                type="text"
                placeholder="Enter Name"
                disabled={!isIdValid}
              />
            </div>

            <div>
              <label htmlFor="Last Name">Last Name
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                type="text"
                placeholder="Enter Last Name"
                disabled={!isIdValid}
              />
            </div>
          </div>
          <div className="w-full grid grid-cols-4 gap-2">
            <div>
              <label htmlFor="code">Email
                {/* <span className="text-red-500 ml-1">*</span> */}
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="email"
                value={formData.email}
                onChange={handleChange}
                type="text"
                placeholder="Enter Email"
                disabled={!isIdValid}
              />
            </div>
            <div>
              <label htmlFor="code">Phone No(Country Code)
                {/* <span className="text-red-500 ml-1">*</span> */}
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                type="text"
                placeholder="Enter Phone Number"
                disabled={!isIdValid}
              />
            </div>
            <div>
              <label htmlFor="code">Phone No(Whats App)
                {/* <span className="text-red-500 ml-1">*</span> */}
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="phoneNumber1"
                value={formData.phoneNumber1}
                onChange={handleChange}
                type="text"
                placeholder="Enter Phone Number"
                disabled={!isIdValid}
              />
            </div>
            <div>
              <label htmlFor="code">Date of Birth
                {/* <span className="text-red-500 ml-1">*</span> */}
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                name="dateOfBirth"
                value={formatDateForInput(formData.dateOfBirth)}
                onChange={handleChange}
                type="date"
                placeholder="Enter Date of Birth"
                disabled={!isIdValid}
              />
            </div>

          </div>

          <div className="w-full grid grid-cols-4 gap-2">
            <div>
              <label htmlFor="admittedDate">Admitted Date
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                name="admittedDate"
                value={formatDateForInput(formData.admittedDate)}
                onChange={handleChange}
                type="date"
                placeholder="Enter Admitted Date"
                disabled={!isIdValid}
              />
            </div>

            <div>
              <label htmlFor="code">Wedding Anniversary</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                name="weddingAnniversary"
                value={formatDateForInput(formData.weddingAnniversary)}
                onChange={handleChange}
                type="date"
                placeholder="Enter Wedding Anniversary"
                disabled={!isIdValid}
              />
            </div>


            <div>
              <label htmlFor="originalRotaryDate">Rotary Date
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                name="originalRotaryDate"
                value={formatDateForInput(formData.originalRotaryDate)}
                onChange={handleChange}
                type="date"
                placeholder="Enter Rotary Date"
                disabled={!isIdValid}
              />
            </div>


            <div >
              <label htmlFor="bloodGroup">Proposed Member</label>
              <Select
                value={formData.proposedByMemberId ? { value: formData.proposedByMemberId, label: formData.memberName } : null}  // Set the value correctly
                onChange={handleMemberChange}
                options={memberlist}
                placeholder="Select Member"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({
                    ...base,
                    width: '100%',
                    minHeight: '38px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    padding: '2px 3px',
                    fontSize: '14px'
                  })
                }}
              />
            </div>



          </div>
          <div className="w-full grid grid-cols-4 gap-2">
            <div>
              <label htmlFor="classification">Classification</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="classification"
                value={formData.classification}
                onChange={handleChange}
                type="text"
                placeholder="Enter Classification"
                disabled={!isIdValid}
              />
            </div>
            <div>
              <label htmlFor="firmName">Firm Name</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="firmName"
                value={formData.firmName}
                onChange={handleChange}
                type="text"
                placeholder="Enter Firm Name"
                disabled={!isIdValid}
              />
            </div>
            <div>
              <label htmlFor="occupation">Profession / Bussiness</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="occupation"
                value={formData.occupation}
                onChange={handleChange}
                type="text"
                placeholder="Enter Profession / Bussiness"
                disabled={!isIdValid}
              />
            </div>
            <div>
              <label htmlFor="address">Address</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="address"
                value={formData.address}
                onChange={handleChange}
                type="text"
                placeholder="Enter Address"
                disabled={!isIdValid}
              />
            </div>
          </div>
          <div className="w-full grid grid-cols-4 gap-2">
            <div>
              <label htmlFor="city">City</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="city"
                value={formData.city}
                onChange={handleChange}
                type="text"
                placeholder="Enter City"
                disabled={!isIdValid}
              />
            </div>
            <div>
              <label htmlFor="state">State</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="state"
                value={formData.state}
                onChange={handleChange}
                type="text"
                placeholder="Enter State"
                disabled={!isIdValid}
              />
            </div>
            <div>
              <label htmlFor="country">Country</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="country"
                value={formData.country}
                onChange={handleChange}
                type="text"
                placeholder="Enter Country"
                disabled={!isIdValid}
              />
            </div>

            <div>
              <label htmlFor="postalCode">Postal Code</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="postalCode"
                value={formData.postalCode}
                onChange={handleChange}
                type="text"
                placeholder="Enter Postal Code"
                disabled={!isIdValid}
              />
            </div>
          </div>







          <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2">
            {/* Rotary Recognitions */}
            <div className="flex flex-col">
              <label htmlFor="rotaryRecognition" className="text-sm font-medium">Rotary Recognitions</label>
              <select
                name="rotaryRecognition"
                value={formData.rotaryRecognition} // Bind state value to the select dropdown
                onChange={handleChange} // Update the gender value on selection change
                className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
              >
                <option value="1">PHF</option>
                <option value="2">AKS</option>
                <option value="3">MD</option>
              </select>
            </div>

            {/* Online Account */}
            <div className="flex flex-col">
              <label htmlFor="onlineAccount" className="text-sm font-medium">Online Account</label>
              <select
                name="onlineAccountwithmyRotary"
                value={formData.onlineAccountwithmyRotary}
                onChange={handleOnlineChange}
                className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
              >
                <option value="1">Yes</option>
                <option value="2">No</option>
              </select>
            </div>

            {/* Gender */}
            <div className="flex flex-col">
              <label htmlFor="gender" className="text-sm font-medium">Gender</label>
              <select
                name="gender"
                value={formData.gender} // Bind state value to the select dropdown
                onChange={handleGenderChange} // Update the gender value on selection change
                className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
              >
                <option value="1">Male</option>
                <option value="2">Female</option>
                <option value="3">Others</option>
              </select>
            </div>


            <div className="flex flex-col">
              <label htmlFor="bloodGroup" className="text-sm font-medium  text-left">Blood Group</label>
              <Select
                value={formData.bloodGroupId ? { value: formData.bloodGroupId, label: formData.bloodGroupName } : null}  // Set the value correctly
                onChange={handleBloodGroupChange}  // Handle blood group changes
                options={bloodGroupOptions}  // Options fetched from the API
                placeholder="Select Blood Group"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({
                    ...base,
                    width: '100%',
                    minHeight: '38px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    padding: '2px 3px',
                    fontSize: '14px'
                  })
                }}
              />
            </div>

            {/* Status */}
            <div className="flex flex-col">
              <label htmlFor="status" className="text-sm font-medium">Status</label>
              <select
                name="status"
                value={formData.status} // Bind the state value to the select dropdown
                onChange={handleChange} // Update the status value on selection change
                className="form-select block w-full py-2 px-3 border border-gray-300 rounded-md text-sm"
              >
                <option value="1">Active</option>
                <option value="2">On-Leave</option>
                <option value="3">Ex-Member</option>
              </select>
            </div>
          </div>

          <div className="w-full grid grid-cols-1 gap-2">

            <div>
              <label htmlFor="code">Remark</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                type="text"
                placeholder="Enter Remarks"
                disabled={!isIdValid}
              />
            </div>


          </div>

          <div className="w-full mb-4 flex flex-col">

            {/* Conditionally render date fields if On-Leave is selected */}
            {formData.status.toString() === "2" && (
              <div className="w-full mb-4 flex">
                <div className="w-1/10 mr-2">
                  <label htmlFor="from date">
                    From Date:
                  </label>
                  <input
                    type="date"
                    name="dateOfLeavingFrom"
                    value={formatDateForInput(formData.dateOfLeavingFrom)}
                    onChange={handleChange}
                    className="block w-full border-gray-300 rounded-md"
                  />
                </div>
                <div className="w-1/10 mr-2">
                  <label htmlFor="todate">
                    To Date:
                  </label>
                  <input
                    type="date"
                    name="dateOfLeavingTo"
                    value={formatDateForInput(formData.dateOfLeavingTo)}
                    onChange={handleChange}
                    className="block w-full border-gray-300 rounded-md"
                  />
                </div>
              </div>
            )}



            {formData.status.toString() === "3" && (
              <div className="w-full mb-4 flex">
                <div className="w-1/10 mr-2">
                  <label htmlFor="expdate">
                    Since:
                  </label>
                  <input
                    type="date"
                    name="expirydate"
                    value={formatDateForInput(formData.expirydate)}
                    onChange={handleChange}
                    className="block w-full border-gray-300 rounded-md"
                  />
                </div>
              </div>
            )}
          </div>


          <div
            style={{
              width: '250px',
              padding: '20px',
              border: '2px solid #ccc',
              borderRadius: '10px',
              backgroundColor: '#fafafa',
              textAlign: 'center',
            }}
          >
            <div className="flex flex-col items-center">
              <input
                type="file"
                accept="image/*"
                onChange={handleFileUpload}
              />
              <div>
                {profilePhoto ? (
                  <img
                    src={profilePhoto}
                    alt="Selected"
                    style={{
                      objectFit: 'cover',
                      maxWidth: '100%',
                      maxHeight: '200px',
                    }}
                    id="fileInput"
                  />
                ) : (
                  <span>No photo uploaded</span>
                )}
              </div>
              {uploadedImageName && <p>Uploaded Image: {uploadedImageName}</p>}
              {uploadedImageUrl && <img src={uploadedImageUrl} alt="Uploaded" style={{ width: '200px', height: '200px' }} />}
            </div>
          </div>

        </div>

        {/* {familyModalOpen && (
            <div className="w-full sm:w-2/5 pl-2">
              <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto' }}> */}

        <Modal open={familyModalOpen} onClose={() => setFamilyModalOpen(false)}>
          {/* <div className="w-full sm:w-2/5 pl-2">
                                              <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto' }}> */}
          <div className="fixed inset-0 flex items-center justify-center z-70">
            <div className="bg-white p-6 rounded-lg  w-full sm:w-1/2" style={{ maxHeight: '90vh', overflowY: 'auto', overflow: 'visible' }}>


              <TableContainer component={Paper}>
                <Table>
                  {/* Table Head */}
                  <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                    <TableRow>
                      <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '7px', fontSize: '16px', fontWeight: 'bold' }}>
                        Member Family Details
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Sl No</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Name</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>DOB</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Blood Group</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>Relation</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '2px' }}>
                        <IconButton onClick={() => toggleModal()} aria-label="add">
                          <AddIcon style={{ color: 'green' }} />
                        </IconButton>
                        <IconButton onClick={togglefamilysModalClose1} aria-label="add">
                          <span style={{ fontSize: '14px', color: 'red' }}>X</span>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Table Body */}
                  <TableBody>
                    {MemberFamilyDatas.map((childdata, index) => (
                      <TableRow key={index}>
                        {/* Serial Number */}
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>{index + 1}</TableCell>

                        {/* Name */}
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>{childdata.name}</TableCell>

                        {/* Date of Birth */}
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>
                          {formatDateForInput(childdata.dateOfBirth)} {/* Ensure date formatting */}
                        </TableCell>

                        {/* Blood Group */}
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>
                          {bloodGroupOptions.find((option) => option.value === childdata.bloodGroupId)?.label}
                        </TableCell>

                        {/* Relation */}
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>{childdata.relation}</TableCell>

                        {/* Edit Icon */}
                        <TableCell sx={{ height: '40px', padding: '5px', textAlign: 'center', padding: '2px' }}>

                          <IconButton onClick={() => toggleModal(childdata, index)}>
                            <EditIcon style={{ fontSize: '20px', color: 'blue' }} />
                          </IconButton>

                          <IconButton onClick={() => (childdata.isActive ? openConfirmDialog(childdata.id) : handleActivate(childdata.id))}>
                            {childdata.isActive ? <DeleteIcon style={{ fontsize: '20px', color: 'brown' }} /> : <ActivateIcon style={{ fontsize: '20px' }} />}
                          </IconButton>




                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>


                  <Dialog
                    open={confirmDialogOpen}
                    onClose={closeConfirmDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                      </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                      <button
                        onClick={closeConfirmDialog}
                        style={{
                          backgroundColor: '#dc3545',
                          color: '#ffffff',
                          border: '1px solid #dc3545',
                          borderRadius: '4px',
                          padding: '8px 16px',
                          cursor: 'pointer',
                          marginRight: '8px',
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleDelete}
                        style={{
                          backgroundColor: '#28a745',
                          color: '#ffffff',
                          border: '1px solid #28a745',
                          borderRadius: '4px',
                          padding: '8px 16px',
                          cursor: 'pointer',
                        }}
                      >
                        Confirm
                      </button>
                    </DialogActions>

                  </Dialog>
                </Table>
              </TableContainer>
            </div>
          </div>
        </Modal>

        {/* Modal for Add/Edit */}
        {isModalOpen && (
          <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full sm:w-1/2" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                <div className="w-full mb-4 flex">
                  <div className="w-1/10 mr-2">
                    <label htmlFor="name">Name</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      type="text"
                      name="name"
                      placeholder="Enter Name"
                      value={newRecordData.name}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="w-1/10 mr-2">
                    <label htmlFor="dateofbirth">Date Of Birth</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      type="date"
                      name="dateOfBirth"
                      value={formatDateForInput(newRecordData.dateOfBirth)}
                      onChange={handleInputChange}
                    />
                  </div>


                </div>

                <div className="w-full mb-4 flex">


                  <div className="w-1/4 mr-2">
                    <label htmlFor="bloodGroup">Blood Group</label>


                    <Select
                      value={newRecordData.bloodGroupId ? bloodGroupOptions.find(option => option.value === newRecordData.bloodGroupId) : null}  // Find the selected value
                      onChange={(selectedOption) => setNewRecordData(prevData => ({
                        ...prevData,
                        bloodGroupId: selectedOption ? selectedOption.value : null
                      }))}  // Use the same options as master
                      options={bloodGroupOptions}
                      placeholder="Bld Grp"
                      isSearchable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                          ...base,
                          width: '100%',
                          minHeight: '38px',
                          border: '1px solid #D1D5DB',
                          borderRadius: '6px',
                          padding: '2px 3px',
                          fontSize: '14px'
                        })
                      }}
                    />




                  </div>


                  <div className="w-1/4 mr-2">
                    <label htmlFor="relation">Relation</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      type="text"
                      name="relation"
                      placeholder="Enter Relation"
                      value={newRecordData.relation}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="isRotarian"
                      name="isRotarian"
                      checked={newRecordData.isRotarian}
                      onChange={handleInputChange}
                    />
                    <label htmlFor="isRotarian" className="ml-2">Rotarian</label>
                  </div>
                </div>

                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                  <Button
                    style={{ color: 'white', fontWeight: 'bolder', padding: '8px 16px', backgroundColor: '#0e728c' }}
                    onClick={addOrEditRecord}
                  >
                    {selectedRecord ? 'Edit Record' : 'Add Record'}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: '#0e728c', // blue-500
                      color: 'white',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      marginLeft: '8px',
                      fontWeight: 'bolder'
                    }}
                    onClick={() => setIsModalOpen(false)}
                  >
                    Cancel
                  </Button>
                </div>

              </div>
            </div>
          </Modal>

        )}


        {/* fees modal */}
        {feesModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-10">
            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '60%' }}>
              <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> GENERATE FEES</h6>

              <div className="w-full mb-4 flex">
                <div className="w-1/2 mr-2">
                  <label htmlFor="fees" className="text-sm font-medium"> Fees </label>
                  <Select
                    value={selectedfees}
                    onChange={handleFeesChange}
                    options={feeslist}
                    placeholder="Select Fees"
                    isSearchable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({
                        ...base,
                        width: '100%',
                        minHeight: '38px',
                        border: '1px solid #D1D5DB',
                        borderRadius: '6px',
                        padding: '2px 3px',
                        fontSize: '14px'
                      })
                    }}
                  />
                </div>
                <div className="w-1/4 mr-2">
                  <label htmlFor="feesAmount">Fees Type</label>
                  <select
                    name="feestype"
                    value={feestype}
                    className="form-select block">
                    <option value="">Select</option>
                    <option value="1">Monthly</option>
                    <option value="2">Quarterly</option>
                    <option value="3">Half Yearly</option>
                    <option value="4">Yearly</option>
                    <option value="0">One Time</option>

                  </select>

                </div>
                <div className="w-1/4 mr-2">
                  <label htmlFor="feesAmount">Fees Amount</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                    value={feesAmount}
                    onChange={(e) => setFeesAmount(e.target.value)} // Allow manual changes if needed
                    type="text"
                    placeholder="Enter Fees Amount"
                    readOnly // Make it readonly if users shouldn't modify it
                  />
                </div>
              </div>
              <div className="w-full mb-4 flex">
                <div className="w-1/4 mr-2">
                  <label htmlFor="code">From Date
                    <span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    className="border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 focus:ring-cyan-500"
                    name="fromDate"
                    value={fromDate}
                    onChange={handleDateChange}
                    type="date"
                  />
                </div>
                <div className="w-1/4 mr-2">
                  <label htmlFor="code">To Date
                    <span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    className="border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 focus:ring-cyan-500"
                    name="toDate"
                    value={toDate}
                    onChange={handleDateChange}
                    type="date"
                  />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                <Button
                  onClick={GenerateData}
                  disabled={isProcessing}
                  variant="contained"
                  style={{
                    color: 'white',
                    fontWeight: 'bolder',
                    backgroundColor: '#5DB996',
                  }}
                >
                  {isProcessing ? (
                    <CircularProgress size={20} style={{ color: 'white' }} />
                  ) : (
                    'GENERATE'
                  )}
                </Button>

                <Button
                  onClick={togglefeesModalClose}
                  disabled={isProcessing}
                  variant="contained"
                  style={{
                    color: 'white',
                    fontWeight: 'bolder',
                    backgroundColor: '#FF748B',
                    marginLeft: '5px',
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}







      </div>


    </div >
  );
};

export default MemberEdit;
